<template>
  <div class="container">
    <div class="table">
      <div class="table-header-title table-header-container">
        {{ $t('standaloneWorkPermit.management.title') }}
      </div>
      <div class="table-header-popover table-header-container">
        <Popover :text="$t('standaloneWorkPermit.management.popover')" />
      </div>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th
                v-for="({ title, mandatory }, index) in tableElements"
                :key="index"
                :class="{ 'required-flag': mandatory && isEditing && hasSWPRight}"
              >
                {{ $t(title) }}
              </th>
              <th />
            </tr>
          </thead>
          <Edit v-if="isEditing && hasSWPRight" />
          <Display
            v-else
            :canInvite="hasSWPRight"
          />
        </table>
      </div>
      <i
        v-if="hasSWPRight && isEditing"
        class="addBtn"
        @click="addNewContractor"
      >
        {{ $t('standaloneWorkPermit.management.addContractor') }}
      </i>
    </div>
  </div>
</template>

<script>

import Popover from '@/controls/Popover'
import MUTATION_TYPES from '@/store/mutation-types'

import { useStoreGetters, useStoreMutations } from '@/store'
import EventBus from '@/utils/eventBus'
import { onMounted, onUnmounted, unref } from 'vue-demi'
import Display from './Display.vue'
import Edit from './Edit.vue'

export default {
  name: 'TenancyContractorsIndex',
  components: {
    Popover,
    Display,
    Edit,
  },
  props: {
    isEditing: Boolean,
    hasSWPRight: Boolean,
  },
  setup (props) {
    const { addNewContractor, startEditContractors, cancelEditContractors, refreshContractors } = useStoreMutations('tenancyContractors', {
      refreshContractors: MUTATION_TYPES.TENANCY_CONTRACTOR_SET_ALL,
      addNewContractor: MUTATION_TYPES.TENANCY_CONTRACTOR_ADD,
      startEditContractors: MUTATION_TYPES.TENANCY_CONTRACTOR_START_EDIT,
      cancelEditContractors: MUTATION_TYPES.TENANCY_CONTRACTOR_CANCEL_EDIT,
    })
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const tableElements = [
      {
        title: 'tender.userAccount',
        mandatory: false,
      },
      {
        title: 'user.name',
        mandatory: true,
      },
      {
        title: 'tenantProjects.contractorType',
        mandatory: true,
      },
      {
        title: 'company.basic.companyName',
        mandatory: true,
      },
      {
        title: 'officeTel',
        mandatory: false,
      },
      {
        title: 'mobile',
        mandatory: true,
      },
      {
        title: 'lastLogin',
        mandatory: false,
      },
      {
        title: 'tender.lastInviteDateTime',
        mandatory: false,
      },
    ]
    onMounted(() => {
      EventBus.$on('standaloneContractors.refresh', () => {
        refreshContractors({ contractors: unref(currentTenancy).tenancyContractors })
        startEditContractors()
      })
      EventBus.$on('standaloneContractors.discard', () => {
        cancelEditContractors()
      })
    })
    onUnmounted(() => {
      EventBus.$off('standaloneContractors.refresh')
      EventBus.$off('standaloneContractors.discard')
    })
    return {
      addNewContractor,
      tableElements,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/commonTable";
.container {
  padding: 10px;
  width: 100%;
}
.table {
  @include non-sticky-table;

  th {
    white-space: nowrap;
  }
  th:last-of-type {
    min-width: 80px;
  }
  .table-header-container {
    display: inline-block
  }
  .table-header-popover {
    font-size: 20px;
  }
  .table-header-title {
    font-size: 20px;
    font-weight: bold;
    background-color: transparent;
  }
  .addBtn {
    border-bottom: 1px solid #0c3a58;
    cursor: pointer;
    font-style: italic;
  }
}
</style>
